import { useState } from 'react';
import { supprimerClubDefinitivement } from '../api';

/** Zone de suppression définitive d'un club — visible seulement pour un club suspendu. */
export default function SuppressionClub({ club, notifier, apres }) {
  const [ouvert, setOuvert] = useState(false);
  const [saisie, setSaisie] = useState('');
  const [occupe, setOccupe] = useState(false);
  const conforme = saisie.trim() === club.nom;
  const supprimer = async () => {
    setOccupe(true);
    try {
      const r = await supprimerClubDefinitivement(club.id, saisie.trim());
      notifier?.(`${club.nom} supprimé : ${r.equipes} équipe(s), ${r.joueurs} joueur(s), ${r.comptes} compte(s).`, 'success');
      apres?.();
    } catch (e) { notifier?.(e.message, 'error'); setOccupe(false); }
  };
  if (!ouvert) return (
    <button type="button" onClick={() => setOuvert(true)}
            style={{ marginTop: 10, background: 'none', border: 'none', color: 'var(--danger)', fontSize: 12, textDecoration: 'underline', cursor: 'pointer', padding: 0 }}>
      Supprimer définitivement ce club…</button>);
  return (
    <div style={{ marginTop: 14, border: '1px solid var(--danger)', borderRadius: 10, padding: '12px 14px', background: 'rgba(230,57,70,.06)' }}>
      <div style={{ fontWeight: 700, color: 'var(--danger)', marginBottom: 6 }}>Suppression définitive</div>
      <div style={{ fontSize: 12.5, lineHeight: 1.55, marginBottom: 10 }}>
        Tout sera effacé : équipes, joueurs, comptes, matchs, feuilles de match, présences, caisses, logo.
        Aucun retour en arrière possible, sauf en restaurant une sauvegarde complète du serveur.
        {club.kwixeo_client_id ? ' La fiche client dans Kwixéo est conservée, avec ses factures.' : ''}
      </div>
      <label style={{ fontSize: 12, color: 'var(--muted)' }}>Pour confirmer, tapez le nom du club : <b style={{ color: 'var(--text)' }}>{club.nom}</b></label>
      <input value={saisie} onChange={e => setSaisie(e.target.value)} aria-label="Nom du club à supprimer" autoComplete="off"
             style={{ display: 'block', width: '100%', marginTop: 6, padding: '8px 10px', borderRadius: 8, border: '1px solid var(--border)', background: 'var(--bg)', color: 'var(--text)' }} />
      <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
        <button type="button" disabled={!conforme || occupe} onClick={supprimer}
                style={{ padding: '8px 14px', borderRadius: 8, border: 'none', fontWeight: 700, fontSize: 12,
                         background: conforme ? 'var(--danger)' : 'var(--border)', color: '#fff', cursor: conforme ? 'pointer' : 'not-allowed' }}>
          {occupe ? 'Suppression…' : 'Supprimer définitivement'}</button>
        <button type="button" className="btn btn-secondary" style={{ width: 'auto', padding: '8px 14px', fontSize: 12 }}
                onClick={() => { setOuvert(false); setSaisie(''); }}>Annuler</button>
      </div>
    </div>);
}
